/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/login/login.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class LoginService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} email
     * @return {?}
     */
    login(email) {
        /** @type {?} */
        const observable = this.http.post("/login/handler", { email });
        // TODO: It would be nice to not reload at this stage, but it is too easy to
        // do it that way to not do it for early versions.
        return observable;
    }
}
LoginService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] },
];
/** @nocollapse */
LoginService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ LoginService.ɵfac = function LoginService_Factory(t) { return new (t || LoginService)(i0.ɵɵinject(i1.HttpClient)); };
/** @nocollapse */ LoginService.ɵprov = i0.ɵɵdefineInjectable({ token: LoginService, factory: LoginService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.http;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9naW4uc2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3Zpc2lvbmljcy9uZy9zcmMvYXBwL2xvZ2luL2xvZ2luLnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxPQUFPLEVBQUMsVUFBVSxFQUFDLE1BQU0sc0JBQXNCLENBQUM7QUFDaEQsT0FBTyxFQUFDLFVBQVUsRUFBQyxNQUFNLGVBQWUsQ0FBQzs7O0FBTXpDLE1BQU0sT0FBTyxZQUFZOzs7O0lBQ3ZCLFlBQW9CLElBQWdCO1FBQWhCLFNBQUksR0FBSixJQUFJLENBQVk7SUFBRyxDQUFDOzs7OztJQUV4QyxLQUFLLENBQUMsS0FBSzs7Y0FDSCxVQUFVLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsZ0JBQWdCLEVBQUUsRUFBQyxLQUFLLEVBQUMsQ0FBQztRQUM1RCw0RUFBNEU7UUFDNUUsa0RBQWtEO1FBQ2xELE9BQU8sVUFBVSxDQUFDO0lBQ3BCLENBQUM7OztZQVhGLFVBQVUsU0FBQztnQkFDVixVQUFVLEVBQUcsTUFBTTthQUNwQjs7OztZQU5PLFVBQVU7O3dFQU9MLFlBQVk7b0RBQVosWUFBWSxXQUFaLFlBQVksbUJBRlYsTUFBTTtrREFFUixZQUFZO2NBSHhCLFVBQVU7ZUFBQztnQkFDVixVQUFVLEVBQUcsTUFBTTthQUNwQjs7Ozs7OztJQUVhLDRCQUF3QiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7SHR0cENsaWVudH0gZnJvbSBcIkBhbmd1bGFyL2NvbW1vbi9odHRwXCI7XG5pbXBvcnQge0luamVjdGFibGV9IGZyb20gXCJAYW5ndWxhci9jb3JlXCI7XG5pbXBvcnQge09ic2VydmFibGV9IGZyb20gXCJyeGpzXCI7XG5cbkBJbmplY3RhYmxlKHtcbiAgcHJvdmlkZWRJbiA6ICdyb290Jyxcbn0pXG5leHBvcnQgY2xhc3MgTG9naW5TZXJ2aWNlIHtcbiAgY29uc3RydWN0b3IocHJpdmF0ZSBodHRwOiBIdHRwQ2xpZW50KSB7fVxuXG4gIGxvZ2luKGVtYWlsKTogT2JzZXJ2YWJsZTxhbnk+IHtcbiAgICBjb25zdCBvYnNlcnZhYmxlID0gdGhpcy5odHRwLnBvc3QoXCIvbG9naW4vaGFuZGxlclwiLCB7ZW1haWx9KTtcbiAgICAvLyBUT0RPOiBJdCB3b3VsZCBiZSBuaWNlIHRvIG5vdCByZWxvYWQgYXQgdGhpcyBzdGFnZSwgYnV0IGl0IGlzIHRvbyBlYXN5IHRvXG4gICAgLy8gZG8gaXQgdGhhdCB3YXkgdG8gbm90IGRvIGl0IGZvciBlYXJseSB2ZXJzaW9ucy5cbiAgICByZXR1cm4gb2JzZXJ2YWJsZTtcbiAgfVxufVxuIl19